import { InputOtpDesignTokens } from '@primeuix/themes/types/inputotp';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/inputotp/index.ts
const otp = componentCommon.inputotp;

export const InputOtpTelekomDT: InputOtpDesignTokens = {
  root: {
    gap: t(otp.gap),
  },
  input: {
    width: t(otp.input.width),
    sm: { width: t(otp.input.sm.width) },
    lg: { width: t(otp.input.lg.width) },
  },
};
